var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"event-properties-item"},[_c('div',{staticClass:"event-label"},[_vm._v(_vm._s(_vm.title))]),_c('div',[_c('el-input',{attrs:{"size":"mini"},on:{"change":_vm.updateProp},model:{value:(_vm.target),callback:function ($$v) {_vm.target=$$v},expression:"target"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }